export default __webpack_public_path__ + "static/media/Santosh Rao.dff7c44d.jpg";